import type { SectorPack } from '../schema.js'

/**
 * Sector Pack "Finanzdienstleistungen" (M4, EDIH-Vertrag §4): generische
 * Terminologie und Regeln fuer Vermoegensverwaltung/Banking-Kontexte.
 * Keine echten Kundendaten, keine regulatorischen Behauptungen — die
 * Terminologie beschreibt Arbeitsbegriffe, keine Rechtspflichten.
 */
export const financePack: SectorPack = {
  id: 'finance',
  version: '1.0.0',
  label: 'Finanzdienstleistungen',
  terminology: {
    'Kundenvermögen': 'Verwaltetes Kundenvermögen (AuM)',
    'Rendite': 'Anlagerendite nach Kosten',
    'Risikoprofil': 'Risikoprofil des Kunden',
    'Anlagestrategie': 'Anlagestrategie (ISA)',
    'Anlagevorschlag': 'Anlagevorschlag (Portfolio)',
    'Marktausblick': 'Marktausblick (House View)',
    'Kundendossier': 'Kundendossier (CRM)',
    'Anlegerschutz': 'Anlegerschutz',
    'Regulatorik': 'Regulatorik (Finanzmarkt)',
    'Compliance-Prüfung': 'Compliance-Prüfung',
    'Factsheet': 'Produkt-Factsheet',
    'Kostentransparenz': 'Kostentransparenz (TER)',
    'Anlagekomitee': 'Anlagekomitee (IC)',
    'Kundenunterlagen': 'Kundenunterlagen (KYC)',
    'Ertragsbericht': 'Ertrags- und Performancebericht',
    'Vorsorge': 'Vorsorgelösung (Säule 3a)',
    'Hypothek': 'Hypothekarfinanzierung',
    'Anlagerichtlinien': 'Anlagerichtlinien (Investment Guidelines)',
    'Due Diligence': 'Due Diligence (DD)',
    'Benchmark': 'Benchmark (Vergleichsindex)',
    'Vermögensverwaltung': 'Vermögensverwaltung (VV)',
    'Gebührenmodell': 'Gebührenmodell (All-in-Fee)',
  },
  taxonomy: {
    topics: [
      'Anlagestrategie',
      'Marktausblick',
      'Kundenbetreuung',
      'Regulatorik',
      'Risikomanagement',
      'Vorsorge',
      'Reporting',
    ],
    documentTypes: [
      'Kundendossier',
      'Marktanalyse',
      'Regulatorisches Rundschreiben',
      'Factsheet',
      'Meeting-Protokoll',
      'Performancebericht',
    ],
  },
  sourceTypes: ['markdown', 'pdf', 'docx', 'email', 'web'],
  connectors: ['imap', 'rss', 'web'],
  approvedSkills: ['research', 'memory', 'blog', 'newsletter', 'presentation', 'data-analysis', 'linkedin'],
  templates: [
    { outputType: 'strategiedokument', templateRef: 'finance/management-briefing' },
    { outputType: 'praesentation', templateRef: 'finance/kunden-review' },
    { outputType: 'newsletter', templateRef: 'finance/marktkommentar' },
  ],
  providerRules: { euOnly: true, allowedProviders: ['mistral'] },
  requiredApprovals: ['strategiedokument', 'praesentation'],
  retentionDefaults: { chatDays: 365, auditDays: 2555 },
  disclaimers: [
    {
      outputType: 'strategiedokument',
      text: 'Dieses Dokument wurde maschinell erstellt und dient der internen Vorbereitung. Es stellt keine Anlageberatung, keine Anlageempfehlung und kein Angebot dar. Alle Angaben sind vor einer Verwendung durch eine qualifizierte Fachperson zu prüfen.',
    },
    {
      outputType: 'praesentation',
      text: 'Diese Präsentation wurde maschinell erstellt und dient der internen Vorbereitung. Sie stellt keine Anlageberatung, keine Anlageempfehlung und kein Angebot dar. Alle Angaben sind vor einer Verwendung durch eine qualifizierte Fachperson zu prüfen.',
    },
    {
      outputType: 'blog_artikel',
      text: 'Dieser Artikel wurde maschinell erstellt. Er stellt keine Anlageberatung, keine Anlageempfehlung und kein Angebot dar und ersetzt keine fachliche Prüfung vor einer Publikation.',
    },
    {
      outputType: 'newsletter',
      text: 'Dieser Newsletter wurde maschinell erstellt. Er stellt keine Anlageberatung, keine Anlageempfehlung und kein Angebot dar und ersetzt keine fachliche Prüfung vor einem Versand.',
    },
  ],
  goldenFixtures: [
    {
      scenario: 'regulatorisches-kundendossier-management-briefing',
      fixtureRefs: ['finance/dossier-muster-ag.md'],
      expect: 'Management-Briefing mit Zitaten auf das Dossier, Pack-Terminologie und Disclaimer; Approval-Pflicht aktiv.',
    },
  ],
}
